<template>
  <div class="bg">
    <el-empty description="这里什么都没有"></el-empty>
    <div style="display: flex;justify-content: center;">
      <el-button @click="goHome">返回首页</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "NotFound",
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goHome() {
      this.$router.push({ path: "/user/index" });
    }
  }
};
</script>
<style>
.bg {
  height: 100%;
  width: 100%;

}
</style>
  
  


// WEBPACK FOOTER //
// src/components/Notfound.vue